import React from 'react';
import { Col, Form, FormGroup, Label, Input } from 'reactstrap';

const _defaultDimensions = 600;
const _defaultCoverDimensions = 1800;

export default class ImageProcessingForm extends React.PureComponent {
  static get defaultDimensions() {
    return _defaultDimensions;
  }

  static get defaultCoverDimensions() {
    return _defaultCoverDimensions;
  }

  constructor(props) {
    super(props);
    this.state = {
      dimensionsCallback: this.props.dimensionsCallback || ((a, v) => true),
      width: this.initialWidth(),
      height: this.initialHeight(),
      format: 'jpeg',
    };
  }

  onInputChange = (e) => {
    const newObj = {};
    const attribute = e.target.name;
    const formVal = e.target.value;
    const val = attribute === 'format' ? formVal : parseInt(formVal);
    newObj[attribute] = val;
    this.setState(newObj);
    this.state.dimensionsCallback(attribute, val);
  }

  initialDimensions() {
    return this.props.cover ? ImageProcessingForm.defaultCoverDimensions : ImageProcessingForm.defaultDimensions;
  }
  initialWidth = ImageProcessingForm.prototype.initialDimensions;
  initialHeight = ImageProcessingForm.prototype.initialDimensions;

  render() {
    const { enabled } = this.props;
    return (<Form className={this.props.className}>
      {this.props.children}
      <FormGroup row>
        <Col sm={4}>
          <FormGroup>
            <Label for="maxWidth">Max Width</Label>
            <Input
              placeholder={this.initialWidth()}
              type="number"
              name="width"
              id="maxWidth"
              disabled={!enabled}
              onChange={this.onInputChange}
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <Label for="maxHeight">Max Height</Label>
            <Input
              placeholder={this.initialHeight()}
              type="number"
              name="height"
              id="maxHeight"
              disabled={!enabled}
              onChange={this.onInputChange}
            />
          </FormGroup>
        </Col>
        <Col sm={4}>
          <FormGroup>
            <Label for="imageType">Image Type</Label>
            <Input
              type="select"
              name="format"
              id="imageType"
              disabled={!enabled}
              onChange={this.onInputChange}
            >
              <option value="jpeg">JPEG</option>
              <option value="png">PNG</option>
            </Input>
          </FormGroup>
        </Col>
      </FormGroup>
    </Form>);
  }
}
